import React, { Component } from 'react';
import QuestionView from '../QuestionView/QestionView';


const QuestionPageView = (props) => {
  return <React.Fragment>
    {/* <LoadCursore /> */}
    <QuestionView {...props} />
  </React.Fragment>
}

export default QuestionPageView;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/QuestionPageView.js